import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, API } from "@/lib/api";
import { StatusBadge, NationBadge } from "@/components/Compliance";
import { ShieldCheck } from "lucide-react";

export default function Verify() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get(`/badge/${token}`).then((r) => setD(r.data)).catch(() => setErr(true)); }, [token]);
  if (err) return <div className="min-h-screen grid place-items-center text-muted-foreground">This badge link is not valid.</div>;
  if (!d) return <div className="min-h-screen grid place-items-center text-muted-foreground">Verifying…</div>;
  return (
    <div className="min-h-screen bg-secondary/40">
      <div className="bg-navy text-white h-16 flex items-center px-6"><Link to="/" className="flex items-center gap-2 font-heading font-extrabold"><img src="/certy-icon.png" alt="" className="h-8 w-8 rounded bg-white p-0.5" /> GetCerty</Link></div>
      <div className="max-w-xl mx-auto p-6">
        <div className="bg-card border border-border rounded-3xl p-8 text-center" data-testid="verify-card">
          <img src={`${API}/badge/${token}.svg`} alt="" className="mx-auto h-11" />
          <h1 className="font-heading text-2xl font-bold mt-5">{d.landlord}</h1>
          <p className="text-sm text-muted-foreground">GetCerty-verified landlord · {d.nations.join(", ")}</p>
          <div className="mt-5 inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-secondary"><ShieldCheck className="text-emerald-brand" /><span className="font-heading text-3xl font-extrabold">{d.score}<span className="text-sm text-muted-foreground">/100</span></span><StatusBadge status={d.status} /></div>
          <ul className="mt-6 text-left space-y-2">
            {d.properties.map((p, i) => <li key={i} className="flex items-center justify-between text-sm p-3 rounded-xl border border-border"><span className="flex items-center gap-2"><NationBadge nation={p.nation} /> {p.name}</span><StatusBadge status={p.status} /></li>)}
          </ul>
          <p className="mt-6 text-[11px] text-muted-foreground">Live status from records held in GetCerty, checked {new Date(d.verified_at).toLocaleString()}. Documents are never shown publicly.</p>
        </div>
      </div>
    </div>
  );
}
